/**
 * Setu Quiz Main Controller
 * Handles quiz navigation, form data, and completion
 */

// Quiz Script Version: 2.0
// console.log('[SetuQuiz] Initializing v3.0');
// Session helper for tab-scoped quiz completion tracking

var SetuQuizSession = {
  VERSION: 'v1',
  PREFIX: 'setuQuiz.',
  
  set: function(key, value) {
    try {
      sessionStorage.setItem(this.PREFIX + key, value);
    } catch (e) {
      console.warn('SessionStorage not available:', e);
    }
  },
  
  get: function(key) {
    try {
      return sessionStorage.getItem(this.PREFIX + key);
    } catch (e) {
      console.warn('SessionStorage not available:', e);
      return null;
    }
  },
  
  clear: function() {
    var keys = ['version', 'completed', 'path', 'timestamp'];
    for (var i = 0; i < keys.length; i++) {
      try {
        sessionStorage.removeItem(this.PREFIX + keys[i]);
      } catch (e) {
        console.warn('SessionStorage not available:', e);
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // console.log('[SetuQuiz] DOM loaded, initializing quiz');
  
  const SetuQuiz = {
    currentStep: 1,
    totalSteps: 12, // FIXED: 12 steps including email capture
    formData: {},
    stepHistory: [1],
    currentPath: null, // 'acne' or 'radiant'
    visibleSections: [],
    
    init: function() {
      // console.log('[SetuQuiz] Init called');
      this.buildVisibleSections();
      this.bindEvents();
      this.updateProgress();
      this.showCurrentStep();
      this.trackQuizStart();
      // console.log('[SetuQuiz] Initialization complete');
    },
    
    buildVisibleSections: function() {
      // Build list of sections, initially excluding BOTH result sections
      // since only one result will be shown based on path
      var sections = document.querySelectorAll('.quiz-section');
      this.visibleSections = [];
      
      for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var sectionType = section.dataset.sectionType;
        
        // On initial build (no path), exclude both result sections
        if (!this.currentPath && sectionType === 'results') {
          continue; // Skip both results initially
        }
        
        this.visibleSections.push(section);
      }
      
      // DON'T override totalSteps - it's hardcoded to 16
    },
    
    rebuildVisibleSections: function() {
      // Rebuild section list based on current path
      this.visibleSections = [];
      var sections = document.querySelectorAll('.quiz-section');
      
      for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var showForPath = section.dataset.showForPath;
        
        // Include section if:
        // 1. It has no path requirement, OR
        // 2. Its path matches current path
        if (!showForPath || showForPath === this.currentPath) {
          this.visibleSections.push(section);
        }
      }
      
      // DON'T override totalSteps - it's hardcoded to 16
      // console.log('Re   th:', this.currentPath, '- Visible sections:', this.visibleSections.length, '- Display steps: 16');
    },
    
    determinePathFromQ1: function(answer) {
      // Options 1 and 6 → acne path
      // All others → radiant path
      // console.log(answer, 'answer');
      this.currentPath = answer;
      var shopRoutineBtn = document.querySelector('.Name-buttonSubmit');      
      var expires = new Date();
      expires.setFullYear(expires.getFullYear() + 20);

      if (answer === 'clear') {
          document.cookie = "product_handle=" + encodeURIComponent('skin-acne-clear-powder') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      } else if (answer === 'brighter') {
        document.cookie = "product_handle=" + encodeURIComponent('glutathione-skin-renew-orange') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      } else if (answer === 'better') {
        document.cookie = "product_handle=" + encodeURIComponent('tummy-probiotic') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      } else if (answer === 'deeper') {
        document.cookie = "product_handle=" + encodeURIComponent('sleep-restore-strips') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      } else if (answer === 'reduce') {
        document.cookie = "product_handle=" + encodeURIComponent('skin-youthful-marine-collagen') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      } else if (answer === 'bulid') {
        document.cookie = "product_handle=" + encodeURIComponent('premium-plant-protein') +
            "; expires=" + expires.toUTCString() +
            "; path=/";
      }
      
      // console.log('Path determined:', this.currentPath, 'from answer:', answer);
      
      // Rebuild sections based on path
      this.rebuildVisibleSections();
      
      // Track path selection
      if (typeof gtag !== 'undefined') {
        gtag('event', 'setu_quiz_path_selected', {
          'event_category': 'quiz',
          'event_label': this.currentPath
        });
      }
    },
    
    bindEvents: function() {
      var self = this;
      
      // Handle radio and checkbox selections
      var radioInputs = document.querySelectorAll('.quiz-form input[type="radio"]');
      var checkboxInputs = document.querySelectorAll('.quiz-form input[type="checkbox"]');
      
      // Handle radio buttons
      for (var i = 0; i < radioInputs.length; i++) {
        var input = radioInputs[i];
        input.addEventListener('change', function(e) {
          self.handleRadioSelection(e.target);
        });
        
        // Add click feedback
        var optionCard = input.closest('.option-card');
        if (optionCard) {
          optionCard.addEventListener('click', function() {
            this.classList.add('clicking');
            var card = this;
            setTimeout(function() {
              card.classList.remove('clicking');
            }, 200);
          });
        }
      }
      
      // Handle checkboxes
      for (var i = 0; i < checkboxInputs.length; i++) {
        var input = checkboxInputs[i];
        input.addEventListener('change', function(e) {
          self.handleCheckboxSelection(e.target);
          // console.log(self, 'self');
        });
        
        // Add click feedback
        var optionCard = input.closest('.option-card');
        if (optionCard) {
          optionCard.addEventListener('click', function() {
            this.classList.add('clicking');
            var card = this;
            setTimeout(function() {
              card.classList.remove('clicking');
            }, 200);
          });
        }
      }
      
      // Handle continue button
      var continueBtn = document.getElementById('continue-btn');
      if (continueBtn) {
        continueBtn.addEventListener('click', function() {
          self.nextStep();
        });
      }

      var skipBtns = document.querySelectorAll('.skip-btn');
      if (skipBtns.length > 0) {
        skipBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            self.nextStep();
          });
        });
      }

      // Handle back button
      var backBtn = document.getElementById('quiz-back-btn');
      if (backBtn) {
        backBtn.addEventListener('click', function() {
          self.previousStep();
        });
      }
      
      // Handle keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && e.target.type === 'radio') {
          self.handleRadioSelection(e.target);
        }
      });

      var nameContinueBtn = document.getElementById('name-continue-btn');
      var nameSkipBtn = document.getElementById('name-skip-btn');
      var nameInput = document.getElementById('quiz-name-input');
      var nameInputeror = document.querySelector('.name-error');

      function toggleButton() {
        if (!nameInput.value.trim()) {
          continueBtn.disabled = true;
          nameInput.classList.add('error');
          nameInputeror.style.display = 'block';
        } else {
          continueBtn.disabled = false;
          nameInput.classList.remove('error');
          nameInputeror.style.display = 'none';
        }
      }

      toggleButton();

      nameInput.addEventListener('input', toggleButton);

      if (nameContinueBtn) {
        nameContinueBtn.addEventListener('click', function() {
          var quizName = nameInput.value.trim();
          if (!quizName) return;

          var expires = new Date();
          expires.setFullYear(expires.getFullYear() + 20);

          document.cookie = "quizName=" + encodeURIComponent(quizName) +
            "; expires=" + expires.toUTCString() +
            "; path=/";

          // console.log("quizName saved permanently:", quizName);
        })
      }

      document.getElementById('phone-continue-btn').addEventListener('click', function () {
        const phoneInput = document.getElementById('quiz-phone-input');
        const phoneError = document.querySelector('.phone-error');
        const phone = phoneInput.value.trim();

        const phoneRegex = /^(?:\+91\s?)?[6-9]\d{9}$/;

        if (!phoneRegex.test(phone)) {
          phoneInput.classList.add('error');
          phoneError.style.display = 'block';
          return;
        }

        phoneInput.classList.remove('error');
        phoneError.style.display = 'none';
        self.nextStep();
      });
      
      var emailContinueBtn = document.getElementById('email-continue-btn');
      var emailSkipBtn = document.getElementById('email-skip-btn');
      var emailInput = document.getElementById('quiz-email-input');
      
      if (emailContinueBtn) {
        emailContinueBtn.addEventListener('click', function() {
          self.handleEmailContinue();
        });
      }
      
      if (emailSkipBtn) {
        emailSkipBtn.addEventListener('click', function() {
          self.handleEmailSkip();
        });
      }
      
      if (emailInput) {
        // Clear error on input
        emailInput.addEventListener('input', function() {
          var errorDiv = document.querySelector('.email-error');
          if (errorDiv) errorDiv.style.display = 'none';
          emailInput.classList.remove('error');
        });
        
        // Submit on Enter key
        emailInput.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            self.handleEmailContinue();
          }
        });
      }
    },
    
    handleRadioSelection: function(input) {
      var questionName = input.name;
      var selectedValue = input.value;
      var selectedLabel = input.dataset.label || input.closest('label').textContent.trim();
      var isRoutingQuestion = input.dataset.isRouting === 'true';
      
      // Store the answer
      this.formData[questionName] = {
        value: selectedValue,
        label: selectedLabel
      };
      
      // If this is the routing question (Q1), determine path
      if (isRoutingQuestion) {
        this.determinePathFromQ1(selectedLabel);
      }
      
      // Add visual feedback
      var optionCard = input.closest('.option-card');
      if (optionCard) {
        optionCard.classList.add('selected');
        
        // Remove selected class from other options
        var otherCards = input.closest('.choice-grid').querySelectorAll('.option-card');
        for (var i = 0; i < otherCards.length; i++) {
          if (otherCards[i] !== optionCard) {
            otherCards[i].classList.remove('selected');
          }
        }
      }
      
      // Track the selection
      this.trackAnswer(questionName, selectedLabel);
      
      // Auto-advance for radio button questions
      var self = this;
      setTimeout(function() {
        self.nextStep();
      }, 400);
    },
    
    handleCheckboxSelection: function(input) {
      var questionName = input.name.replace('[]', '');
      var selectedValue = input.value;
      var selectedLabel = input.dataset.label || input.closest('label').textContent.trim();
      
      // console.log('[SetuQuiz] Checkbox changed:', questionName, 'checked:', input.checked, 'label:', selectedLabel);
      
      // Initialize array if needed
      if (!this.formData[questionName]) {
        this.formData[questionName] = {
          values: [],
          labels: []
        };
      }
      
      // Update formData FIRST (don't depend on optionCard existing)
      if (input.checked) {
        this.formData[questionName].values.push(selectedValue);
        this.formData[questionName].labels.push(selectedLabel);
        // console.log('[SetuQuiz] Added to', questionName + ':', this.formData[questionName]);
      } else {
        var valueIndex = this.formData[questionName].values.indexOf(selectedValue);
        var labelIndex = this.formData[questionName].labels.indexOf(selectedLabel);
        if (valueIndex > -1) this.formData[questionName].values.splice(valueIndex, 1);
        if (labelIndex > -1) this.formData[questionName].labels.splice(labelIndex, 1);
        // console.log('[SetuQuiz] Removed from', questionName + ':', this.formData[questionName]);
      }
      
      // Add visual feedback (if optionCard exists)
      var optionCard = input.closest('.option-card');
      if (optionCard) {
        if (input.checked) {
          optionCard.classList.add('selected');
        } else {
          optionCard.classList.remove('selected');
        }
      }
      
      // Track the selection
      this.trackAnswer(questionName, selectedLabel);
      
      // Update continue button visibility
      this.updateContinueButtonForCheckboxes();
    },
    
    updateContinueButtonForCheckboxes: function() {
      var currentSection = this.visibleSections[this.currentStep - 1];
      if (!currentSection) return;
      
      var hasCheckboxes = currentSection.querySelectorAll('input[type="checkbox"]').length > 0;
      if (!hasCheckboxes) return;
      
      var selectedCheckboxes = currentSection.querySelectorAll('input[type="checkbox"]:checked');
      var footer = document.getElementById('quiz-footer');
      
      if (footer) {
        if (selectedCheckboxes.length > 0) {
          footer.style.display = 'block';
        } else {
          footer.style.display = 'none';
        }
      }
    },
    
    validateEmail: function(email) {
      // Basic email validation regex
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    
    handleEmailContinue: function() {
      var emailInput = document.getElementById('quiz-email-input');
      var errorDiv = document.querySelector('.email-error');
      
      if (!emailInput) return;
      
      var email = emailInput.value.trim();
      
      // Validate email
      if (!email || !this.validateEmail(email)) {
        if (errorDiv) {
          errorDiv.style.display = 'block';
        }
        emailInput.classList.add('error');
        emailInput.focus();
        return;
      }
      
      // Store email in formData
      this.formData['email'] = {
        value: email,
        label: email
      };
      
      // console.log('Email captured:', email);
      
      // Track email capture
      if (typeof gtag !== 'undefined') {
        gtag('event', 'quiz_email_captured', {
          'event_category': 'engagement',
          'event_label': 'setu_quiz'
        });
      }
      
      // Proceed to results
      this.nextStep();
    },
    
    handleEmailSkip: function() {
      // console.log('Email capture skipped');
      
      // Track skip
      if (typeof gtag !== 'undefined') {
        gtag('event', 'quiz_email_skipped', {
          'event_category': 'engagement',
          'event_label': 'setu_quiz'
        });
      }
      
      // Proceed to results without email
      this.nextStep();
    },
    
    nextStep: function() {
      if (this.currentStep < this.totalSteps) {
        var self = this;
        this.hideCurrentStep();
        
        // Wait for hide animation to complete before showing next step
        setTimeout(function() {
          self.currentStep++;
          self.stepHistory.push(self.currentStep);
          self.showCurrentStep();
          self.updateProgress();
          self.updateBackButton();
          self.scrollToTop();
          
          // Check if we've reached the results page (final step)
          var currentSection = self.visibleSections[self.currentStep - 1];
          if (currentSection && currentSection.dataset.sectionType === 'results') {
            // Save completion state when reaching results
            self.completeQuiz();
          }
          
          // Handle loading steps with auto-advance
          if (currentSection && currentSection.dataset.sectionType === 'loading') {
            setTimeout(function() {
              self.currentStep++;
              self.stepHistory.push(self.currentStep);
              self.showCurrentStep();
              self.updateProgress();
              self.updateBackButton();
              self.scrollToTop();
              // self.animateLoadingPoints(currentSection);
            }, 300);
            // Auto-advance now handled by animateLoadingPoints after final point completes
          }
        }, 350);
      } else {
        this.completeQuiz();
      }
    },
    
    previousStep: function() {
      if (this.stepHistory.length > 1) {
        var self = this;
        this.hideCurrentStep();
        
        // Wait for hide animation to complete before showing previous step
        setTimeout(function() {
          self.stepHistory.pop();
          self.currentStep = self.stepHistory[self.stepHistory.length - 1];
          self.showCurrentStep();
          self.updateProgress();
          self.updateBackButton();
          self.scrollToTop();
        }, 350);
      }
    },
    
    showCurrentStep: function() {
      // Remove any temporary pre-check hiding styles
      var preCheckStyles = document.querySelectorAll('style');
      for (var j = 0; j < preCheckStyles.length; j++) {
        if (preCheckStyles[j].textContent.includes('quiz-section')) {
          preCheckStyles[j].remove();
        }
      }
      
      // CRITICAL: First, hide ALL sections to prevent overlap
      var allSections = document.querySelectorAll('.quiz-section');
      for (var i = 0; i < allSections.length; i++) {
        allSections[i].style.display = 'none';
        allSections[i].classList.remove('fade-in');
      }
      
      // Now show only the current section
      var currentSection = this.visibleSections[this.currentStep - 1];
      
      if (currentSection) {
        currentSection.style.display = 'block';
        
        setTimeout(function() {
          currentSection.classList.add('fade-in');
        }, 50);
        
        // Show/hide footer based on section type
        var footer = document.getElementById('quiz-footer');
        var quizMain = document.querySelector('.quiz-main');
        var header = document.querySelector('.setu-quiz-header');
        var sectionType = currentSection.dataset.sectionType;
        
        var hasCheckboxes = currentSection.querySelectorAll('input[type="checkbox"]').length > 0;
        
        if (sectionType === 'intro_question' || sectionType === 'results' || sectionType === 'loading' || sectionType === 'email_capture' || sectionType === 'name_capture' || sectionType === 'phone_capture' || sectionType === '' ) {
          footer.style.display = 'none';
          if (quizMain) quizMain.classList.add('no-footer');
        } else if (sectionType === 'multiple_choice' && !hasCheckboxes) {
          footer.style.display = 'none';
          if (quizMain) quizMain.classList.add('no-footer');
        } else if (sectionType === 'path_question' && !hasCheckboxes) {
          footer.style.display = 'none';
          if (quizMain) quizMain.classList.add('no-footer');
        } else if (hasCheckboxes) {
          this.updateContinueButtonForCheckboxes();
          if (quizMain) quizMain.classList.remove('no-footer');
        } else if (sectionType === 'info' || sectionType === 'path_info') {
          footer.style.display = 'block';
          if (quizMain) quizMain.classList.remove('no-footer');
        } else {
          footer.style.display = 'block';
          if (quizMain) quizMain.classList.remove('no-footer');
        }

        if (sectionType === 'loading') {
          header.style.display = 'none';
        }

        if (sectionType === 'path_info') {
          footer.style.display = 'none';
          header.style.display = 'none';
        }
      }
    },
    
    hideCurrentStep: function() {
      var currentSection = this.visibleSections[this.currentStep - 1];
      if (currentSection) {
        currentSection.classList.remove('fade-in');
        setTimeout(function() {
          currentSection.style.display = 'none';
        }, 300);
      }
    },
    
    updateProgress: function() {
      var progressFill = document.querySelector('.progress-fill');
      var progressText = document.querySelector('.progress-text');
      
      if (progressFill && progressText) {
        // var percentage = Math.min((this.currentStep / this.totalSteps) * 100, 100);
        var percentage = Math.round(Math.min((this.currentStep / this.totalSteps) * 100, 100));
        
        progressFill.style.setProperty('width', percentage + '%', 'important');
        progressFill.style.setProperty('background', 'linear-gradient(to right,#fb923c , #f472b6)', 'important');
        progressFill.style.setProperty('display', 'block', 'important');
        
        progressText.textContent = percentage + '%';
      }
    },
    
    updateBackButton: function() {
      var backBtn = document.getElementById('quiz-back-btn');
      if (backBtn) {
        if (this.currentStep > 1) {
          backBtn.style.display = 'flex';
        } else {
          backBtn.style.display = 'none';
        }
      }
    },
    
    animateLoadingPoints: function(loadingSection) {
      var loadingPoints = loadingSection.querySelectorAll('.loading-point');
      var self = this;
      
      if (loadingPoints.length === 0) return;
      
      // Reset all points to pending state
      for (var i = 0; i < loadingPoints.length; i++) {
        loadingPoints[i].classList.remove('active');
        loadingPoints[i].classList.remove('done');
      }
      
      // Animate each point sequentially: pending → active (spinner) → done (checkmark)
      for (var i = 0; i < loadingPoints.length; i++) {
        var point = loadingPoints[i];
        var delay = parseInt(point.dataset.delay) || (i + 1) * 1500;
        var isLastPoint = i === loadingPoints.length - 1;
        
        (function(point, delay, isLast) {
          // Activate point (show spinner)
          setTimeout(function() {
            point.classList.add('active');
          }, delay);
          
          // Mark as done (show checkmark) after 1200ms of spinning
          setTimeout(function() {
            point.classList.remove('active');
            point.classList.add('done');
            
            // Auto-advance after final point completes
            if (isLast) {
              setTimeout(function() {
                self.nextStep();
              }, 500);
            }
          }, delay + 1200);
        })(point, delay, isLastPoint);
      }
    },
    
    scrollToTop: function() {
      if (window.scrollTo) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    
    trackQuizStart: function() {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'setu_quiz_started', {
          'event_category': 'engagement',
          'event_label': 'setu_nutrition_quiz'
        });
      }
      
      if (typeof fbq !== 'undefined') {
        fbq('track', 'InitiateCheckout', {
          content_name: 'Setu Quiz Started'
        });
      }
    },
    
    trackAnswer: function(questionName, answer) {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'quiz_answer', {
          'event_category': 'engagement',
          'event_label': questionName,
          'custom_parameter': answer
        });
      }
    },
    
    completeQuiz: function() {
      localStorage.setItem('setuQuizCompleted', 'true');
      localStorage.setItem('setuQuizPath', this.currentPath);
      localStorage.setItem('setuQuizData', JSON.stringify(this.formData));
      localStorage.setItem('setuQuizTimestamp', Date.now().toString());
      
      // Save to sessionStorage for same-tab resume
      SetuQuizSession.set('version', SetuQuizSession.VERSION);
      SetuQuizSession.set('completed', 'true');
      SetuQuizSession.set('path', this.currentPath);
      SetuQuizSession.set('timestamp', new Date().toISOString());
      
      // Send to Make webhook (fire and forget - non-blocking)
      if (typeof window.SetuQuizWebhook !== 'undefined') {
        try {
          window.SetuQuizWebhook.send(this.formData, this.currentPath);
        } catch (e) {
          console.warn('Failed to send quiz data to webhook:', e);
        }
      }
      
      if (typeof gtag !== 'undefined') {
        gtag('event', 'setu_quiz_completed', {
          'event_category': 'conversion',
          'event_label': 'setu_nutrition_quiz',
          'path': this.currentPath,
          'value': 1
        });
      }
      
      if (typeof fbq !== 'undefined') {
        fbq('track', 'CompleteRegistration', {
          content_name: 'Setu Quiz Completed',
          status: true
        });
      }
      
      // console.log('Setu Quiz completed:', this.formData, 'Path:', this.currentPath);
    },
    
    getResults: function() {
      return {
        formData: this.formData,
        currentPath: this.currentPath,
        currentStep: this.currentStep,
        isCompleted: this.currentStep >= this.totalSteps
      };
    },
    
    retakeQuiz: function() {
      SetuQuizSession.clear();
      window.location.reload();
    }
  };
  
  window.SetuQuiz = SetuQuiz;
  
  // CRITICAL: Check for completed session before initializing
  // If user completed quiz in this session, MUST go directly to results (step 16)
  var sessionCompleted = SetuQuizSession.get('completed');
  var sessionVersion = SetuQuizSession.get('version');
  var savedPath = SetuQuizSession.get('path');
  
  if (sessionCompleted === 'true' && sessionVersion === SetuQuizSession.VERSION) {
    if (savedPath === 'radiant' || savedPath === 'acne') {
      // console.log('SESSION RESUME: Jumping to results for path:', savedPath);
      
      // Set path BEFORE initialization
      SetuQuiz.currentPath = savedPath;
      
      // Initialize quiz
      SetuQuiz.init();
      
      // FORCE jump to step 16 (results) - NO DELAYS
      SetuQuiz.rebuildVisibleSections();
      SetuQuiz.currentStep = 16;
      SetuQuiz.stepHistory = [16];
      SetuQuiz.showCurrentStep();
      SetuQuiz.updateProgress();
      // SetuQuiz.updateBackButton();
      
      // console.log('SESSION RESUME: Now at step', SetuQuiz.currentStep, 'of', SetuQuiz.totalSteps);
    } else {
      // Invalid path, clear session and start fresh
      // console.log('SESSION RESUME: Invalid path, clearing and starting fresh');
      SetuQuizSession.clear();
      SetuQuiz.init();
    }
  } else {
    // Normal quiz start
    // console.log('FRESH START: No session found, starting from step 1');
    SetuQuiz.init();
  }
});

const scriptURL = 'https://script.google.com/macros/s/AKfycbyNNVOZAbi-zCJ5Q3VZ7X7WjYVCEcfsZLO2whmU1lst2JV0W2zqnvznNa9SfTgOqvgPLg/exec';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.Name-buttonSubmit').addEventListener('click', async (e) => {

    document.querySelector('.Name-buttonSubmit').classList.add('loading');
    
    const checkedInputs = document.querySelectorAll('input[name="primary_concern"]:checked');
    const primary_concernValues = Array.from(checkedInputs).map(input => input.value);

    const acne_patterncheckedInputs = document.querySelectorAll('input[name="acne_pattern"]:checked');
    const acne_patternValues = Array.from(acne_patterncheckedInputs).map(input => input.value);
    const most_dayscheckedInputs = document.querySelectorAll('input[name="most_days"]:checked');
    const most_daysValues = Array.from(most_dayscheckedInputs).map(input => input.value);
    const current_routinecheckedInputs = document.querySelectorAll('input[name="current_routine"]:checked');
    const current_routineValues = Array.from(current_routinecheckedInputs).map(input => input.value);
    const frustratecheckedInputs = document.querySelectorAll('input[name="frustrated"]:checked');
    const frustratedValues = Array.from(frustratecheckedInputs).map(input => input.value);
    const worried_thatcheckedInputs = document.querySelectorAll('input[name="worried_that"]:checked');
    const worried_thatValues = Array.from(worried_thatcheckedInputs).map(input => input.value);
    const right_nowcheckedInputs = document.querySelectorAll('input[name="right_now"]:checked');
    const right_nowValues = Array.from(right_nowcheckedInputs).map(input => input.value);

    const loveMycheckedInputs = document.querySelectorAll('input[name="love my skin"]:checked');
    const loveMyValues = Array.from(loveMycheckedInputs).map(input => input.value);
    const skinUsuallycheckedInputs = document.querySelectorAll('input[name="My skin usually looks"]:checked');
    const skinUsuallyValues = Array.from(skinUsuallycheckedInputs).map(input => input.value);
    const myRoutinecheckedInputs = document.querySelectorAll('input[name="My routine is"]:checked');
    const myRoutineValues = Array.from(myRoutinecheckedInputs).map(input => input.value);
    const frustratedBecausecheckedInputs = document.querySelectorAll('input[name="I am frustrated because"]:checked');
    const frustratedBecauseValues = Array.from(frustratedBecausecheckedInputs).map(input => input.value);
    const idontFixcheckedInputs = document.querySelectorAll('input[name="If I dont fix it"]:checked');
    const idontFixValues = Array.from(idontFixcheckedInputs).map(input => input.value);
    const somethingThatcheckedInputs = document.querySelectorAll('input[name="I just want something that"]:checked');
    const somethingThatValues = Array.from(somethingThatcheckedInputs).map(input => input.value);

    const wakeUpfeelingcheckedInputs = document.querySelectorAll('input[name="I want to wake up feeling"]:checked');
    const wakeUpfeelingValues = Array.from(wakeUpfeelingcheckedInputs).map(input => input.value);
    const sleepUsuallycheckedInputs = document.querySelectorAll('input[name="My sleep usually is"]:checked');
    const sleepUsuallyValues = Array.from(sleepUsuallycheckedInputs).map(input => input.value);
    const nightsLookcheckedInputs = document.querySelectorAll('input[name="My nights look like"]:checked');
    const nightsLookValues = Array.from(nightsLookcheckedInputs).map(input => input.value);
    const frustratedcheckedInputs = document.querySelectorAll('input[name="frustrated because"]:checked');
    const frustrateValues = Array.from(frustratedcheckedInputs).map(input => input.value);
    const thisContinuescheckedInputs = document.querySelectorAll('input[name="If this continues"]:checked');
    const thisContinuesValues = Array.from(thisContinuescheckedInputs).map(input => input.value);
    const somethingcheckedInputs = document.querySelectorAll('input[name="something that"]:checked');
    const somethingValues = Array.from(somethingcheckedInputs).map(input => input.value);

    const skinLookcheckedInputs = document.querySelectorAll('input[name="I want my skin to look"]:checked');
    const skinLookValues = Array.from(skinLookcheckedInputs).map(input => input.value);
    const iNoticecheckedInputs = document.querySelectorAll('input[name="I notice"]:checked');
    const iNoticeValues = Array.from(iNoticecheckedInputs).map(input => input.value);
    const routineIs4checkedInputs = document.querySelectorAll('input[name="My routine is4"]:checked');
    const routineIs4Values = Array.from(routineIs4checkedInputs).map(input => input.value);
    const frustrated4checkedInputs = document.querySelectorAll('input[name="I am frustrated because4"]:checked');
    const frustrated4Values = Array.from(frustrated4checkedInputs).map(input => input.value);
    const ignoreThischeckedInputs = document.querySelectorAll('input[name="If I ignore this"]:checked');
    const ignoreThisValues = Array.from(ignoreThischeckedInputs).map(input => input.value);
    const something4checkedInputs = document.querySelectorAll('input[name="I want something that4"]:checked');
    const something4Values = Array.from(something4checkedInputs).map(input => input.value);

    const wanttoFeelcheckedInputs = document.querySelectorAll('input[name="I want to feel"]:checked');
    const wanttoFeelValues = Array.from(wanttoFeelcheckedInputs).map(input => input.value);
    const currentlyIfeelcheckedInputs = document.querySelectorAll('input[name="Currently I feel"]:checked');
    const currentlyIfeelValues = Array.from(currentlyIfeelcheckedInputs).map(input => input.value);
    const activityLavelcheckedInputs = document.querySelectorAll('input[name="My activity level is"]:checked');
    const activityLavelValues = Array.from(activityLavelcheckedInputs).map(input => input.value);
    const frustrated5checkedInputs = document.querySelectorAll('input[name="I am frustrated because5"]:checked');
    const frustrated5Values = Array.from(frustrated5checkedInputs).map(input => input.value);
    const continue5checkedInputs = document.querySelectorAll('input[name="If this continues5"]:checked');
    const continue5Values = Array.from(continue5checkedInputs).map(input => input.value);
    const something5checkedInputs = document.querySelectorAll('input[name="I want something that5"]:checked');
    const something5Values = Array.from(something5checkedInputs).map(input => input.value);



    const iidentifyascheckedInputs = document.querySelectorAll('input[name="I identify as"]:checked');
    const iidentifyasValues = Array.from(iidentifyascheckedInputs).map(input => input.value);
    const thisYearcheckedInputs = document.querySelectorAll('input[name="This year, I am"]:checked');
    const thisYearValues = Array.from(thisYearcheckedInputs).map(input => input.value);

    const name = document.getElementById('quiz-name-input').value;
    const email = document.getElementById('quiz-email-input').value;
    const phone = document.getElementById('quiz-phone-input').value;
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB");
    const formData = new FormData();
    
    formData.append("Date", formattedDate); 
    formData.append("My main health or skin goal right now is…", primary_concernValues);  
    formData.append("I’d love my skin to look…", acne_patternValues);   
    formData.append("On most days, my skin tends to…", most_daysValues);  
    formData.append("My current routine is…", current_routineValues);   
    formData.append("I am frustrated because…1", frustratedValues);   
    formData.append("If this continues, I’m worried that…", worried_thatValues); 
    formData.append("Right now I want something that…", right_nowValues);   

    formData.append("I’d love my skin to feel…", loveMyValues);   
    formData.append("My skin usually looks…", skinUsuallyValues);  
    formData.append("My routine is…2", myRoutineValues);   
    formData.append("I am frustrated because…2", frustratedBecauseValues);   
    formData.append("If I don’t fix it…", idontFixValues);   
    formData.append("I just want something that…", somethingThatValues); 

    formData.append("I want to wake up feeling…", wakeUpfeelingValues);   
    formData.append("My sleep usually is…", sleepUsuallyValues);  
    formData.append("My nights look like…", nightsLookValues);   
    formData.append("I am frustrated because…3", frustrateValues);   
    formData.append("If this continues…", thisContinuesValues);   
    formData.append("I want something that…", somethingValues); 

    formData.append("I want my skin to look…", sleepUsuallyValues);   
    formData.append("I notice…", iNoticeValues);  
    formData.append("My routine is…4", routineIs4Values);   
    formData.append("I am frustrated because…4", frustrated4Values);  
    formData.append("If I ignore this…", ignoreThisValues);   
    formData.append("I want something that…4", something4Values); 

    formData.append("I want to feel…", wanttoFeelValues);   
    formData.append("Currently I feel…", currentlyIfeelValues);  
    formData.append("My activity level is…", activityLavelValues);   
    formData.append("I am frustrated because…5", frustrated5Values);  
    formData.append("If this continues…5", continue5Values);   
    formData.append("I want something that…5", something5Values); 

    formData.append("I identify as…", iidentifyasValues);   
    formData.append("This year, I am…", thisYearValues);   
    formData.append("Name", name);   
    formData.append("Email", email);   
    formData.append("Phone number", phone);  
    


    try {
        const res = await fetch(scriptURL, {
            method: 'POST',
            body: formData
        });

        const text = await res.text();

        if (res.ok) {
          window.location.href = '/pages/skin-results';
            // alert('Data saved successfully!');
        } else {
            alert('Error saving data: ' + text);
        }
    } catch (err) {
        alert('Error: ' + err.message);
        console.error(err);
    }
  });
});